module.exports = __webpack_public_path__ + "02062f6110cc543fb8e6e8649d46a4b7.svg";